const RoleMenuAccess = {
  "4b03b020-194f-45a9-810a-06801ffa513c": [ // Submitter
    "/app/dashboard",
    "/app/report/wbs",
  ],
  "7424936e-7c35-4461-8dd8-9e2e2e80f3b4": [ // Application Administrator
  "/app/dashboard",
  "/app/user-management",
  "/app/user-management/role/list",
  "/app/user-management/user/list",
  "/app/master/WorkingCalendar/list",
  "/app/organization-structure/organization/list",
  "/app/organization-structure/chart",
  "/app/organization-structure/division/list",
  "/app/organization-structure/department/list",
  "/app/organization-structure/position/list",
  "/app/wbs-init/list",
  "/app/report/wbs",
  "/app/report/organization",
],
  "0f418ead-0b68-4af4-b141-0b894503f559": [ // Organization Administrator
    "/app/dashboard",
    "/app/user-management",
    "/app/user-management/role/list",
    "/app/user-management/user/list",
    "/app/master/WorkingCalendar/list",
    "/app/organization-structure/organization/list",
    "/app/organization-structure/chart",
    "/app/organization-structure/division/list",
    "/app/organization-structure/department/list",
    "/app/organization-structure/position/list",
    "/app/wbs-init/list",
    "/app/report/wbs",
    "/app/report/organization",
  ],
  "5febd304-7990-4ddd-a9ce-18812aae2a4f": [ // Reviewer
    "/app/dashboard",
    "/app/report/wbs",
    "/app/report/organization",
  ],
  "801e1d35-a9b5-4ef3-972d-c005cf503243": [ // Approver
    "/app/dashboard",
    "/app/report/wbs",
    "/app/report/organization",
  ],
};

export default RoleMenuAccess;
